import React, { Component } from "react";
//Alert dialog
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";
import { timeConvert } from "../Branches/ContactPageTools";
import moment from "moment";

class StoreClosedDialog extends Component {
  render() {
    const { language, customTexts } = this.props;
    return (
      <Dialog
        open={this.props.dialogOpen}
        onClose={(e) => {
          this.props.onClose(e);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            minWidth: "300px",
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ textAlign: language == "english" ? "left" : "right" }}
        >
          {this.props.type == 1
            ? language == "english"
              ? "Store cannot accept orders"
              : "المتجر لا يتمكن من استلام الطلبات حاليا"
            : language == "english"
              ? "Sorry!"
              : "نأسف"}
        </DialogTitle>
        <DialogContent>
          {this.props.type == 0 ? (
            <DialogContentText
              id="alert-dialog-description"
              style={{ textAlign: language == "english" ? "left" : "right" }}
            >
              {language == "english"
                ? !this.props.settings.show_busy_until_time
                  ? "Store is busy"
                  : `Kindly return back by ${moment(
                      this.props.untilDate,
                      "YYYY-MM-DD",
                    ).format("MMMM Do")} ${timeConvert(
                      this.props.untilTime,
                      language,
                    )} and you'll be able to continue shopping`
                : !this.props.settings.show_busy_until_time
                  ? `المتجر مغلق حالياً`
                  : `الرجاء محاولة متابعة تسوقك بعد تاريخ ${moment(
                      this.props.untilDate,
                      "YYYY-MM-DD",
                    ).format("MM/DD")} الساعة ${timeConvert(
                      this.props.untilTime,
                      language,
                    )}`}
            </DialogContentText>
          ) : (
            <DialogContentText
              id="alert-dialog-description"
              style={{ textAlign: language == "english" ? "left" : "right" }}
            >
              {language == "english"
                ? customTexts.store_busy_message
                : customTexts.store_busy_message_ar}
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: language == "english" ? "flex-end" : "flex-start",
          }}
        >
          <Button
            onClick={(e) => {
              this.props.onClose(e);
              e.stopPropagation();
            }}
            color="primary"
          >
            {language == "english" ? "Ok" : "حسنا"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    customTexts: state.store.store.settings.custom_texts,
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(StoreClosedDialog);
